import { render, staticRenderFns } from "./PageLetUsKnow.vue?vue&type=template&id=107afe69"
import script from "./PageLetUsKnow.vue?vue&type=script&lang=js"
export * from "./PageLetUsKnow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports